/* Ironica — card prodotto: swipe foto, vista Indossato / Still life, hover desktop */
(function () {
  var KEY = 'ir_view';
  var root = document.documentElement;
  function getView() { try { return localStorage.getItem(KEY) || 'indossato'; } catch (e) { return 'indossato'; } }
  function setView(v) {
    try { localStorage.setItem(KEY, v); } catch (e) {}
    root.setAttribute('data-ir-view', v);
    document.querySelectorAll('[data-ir-strip]').forEach(function (s) { s.scrollLeft = 0; dots(s); });
    document.querySelectorAll('[data-ir-set-view]').forEach(function (b) {
      var on = b.getAttribute('data-ir-set-view') === v;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function dots(strip) {
    var d = strip.parentElement && strip.parentElement.querySelector('.ir-dots');
    if (!d || !strip.clientWidth) return;
    var i = Math.round(strip.scrollLeft / strip.clientWidth);
    Array.prototype.forEach.call(d.children, function (el, n) { el.classList.toggle('on', n === i); });
  }
  document.addEventListener('scroll', function (e) {
    if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-ir-strip')) dots(e.target);
  }, true);
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ir-set-view]');
    if (b) { setView(b.getAttribute('data-ir-set-view')); return; }
    var strip = e.target.closest && e.target.closest('[data-ir-strip]');
    if (strip) {
      var card = strip.closest('.product-card');
      var a = card && card.querySelector('.product-card__link-overlay');
      if (a && a.href) { if (e.metaKey || e.ctrlKey) window.open(a.href, '_blank'); else window.location.href = a.href; }
    }
  });
  if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('mouseover', function (e) {
      var card = e.target.closest && e.target.closest('.product-card');
      if (!card || card._irHover) return;
      var s = card.querySelector('[data-ir-strip]'); if (!s) return;
      card._irHover = true; s.scrollTo({ left: s.clientWidth, behavior: 'instant' }); dots(s);
      card.addEventListener('mouseleave', function () { card._irHover = false; s.scrollTo({ left: 0, behavior: 'instant' }); dots(s); }, { once: true });
    });
  }
  function init() { setView(getView()); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
